<template>
  <div class="relative rounded-md shadow-sm">
    <div v-if="loading" class="flex items-center pointer-events-none">
      <input
        type="text"
        class="form-input block w-full border border-gray-300 rounded-md shadow-sm sm:text-sm sm:leading-5 disabled:cursor-not-allowed opacity-50"
        disabled="disabled"
        placeholder="Select Product"
      />
      <LoadingSpinner
        class="w-8 text-gray-400 absolute inset-y-0 right-0 mt-2 flex items-center pointer-events-none"
      />
    </div>
    <div v-else>
      <model-select
        required="true"
        :options="reducedOptions"
        v-model="product_id"
        placeholder="Select Product"
        @searchchange="filterOptions"
        :isDisabled="loading"
        name="something"
      >
      </model-select>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import { ApiFactory } from "@/api/ApiFactory.js";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "ProductSelect",
  components: {
    ModelSelect,
  },
  props: {
    reduceOpts: {
      type: Number,
      default: 0,
      required: false,
    },
    filters: Array,
    returnProductDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      optionSearch: "",
      items: [],
      products: [],
      product_id: null,
      loading: true,
    };
  },
  methods: {
    filterOptions(search) {
      if (search) {
        this.optionSearch = search;
      }
    },
  },
  computed: {
    reducedOptions() {
      if (this.reduceOpts === 0) return this.options;

      return this.options
        .filter((option) => {
          return option.text
            .toLowerCase()
            .includes(this.optionSearch.toLowerCase());
        })
        .slice(0, this.reduceOpts);
    },
    showSpinner() {
      if (this.productId === null) return false;
      return this.loading;
    },
  },
  created() {},
  watch: {
    product_id() {
      if (this.returnProductDetails) {
        this.products.find((product) => {
          if (product.id === this.product_id) {
            this.$emit("product-details", product);
          }
        });
      }
      this.$emit("change-handler", this.product_id);
    },
  },
  async beforeMount() {
    ApiFactory.get("inventories").products().then((response) => {
      this.products = response.data.body;
      this.options = this.products
        .filter((product) => {
          if (product.name === null && product.botanical_name === null)
            return false;
          return product;
        })
        .map((product) => {
          return {
            value: product.id,
            text: `${product.name} (${product.botanical_name})`
          };
        });
      this.loading = false;
      this.$emit('loaded');
    });
  },
};
</script>
